<template>
  <q-dialog ref="docModal" maximized >
            <q-layout view="Lhh lpR fff" container class="bg-white">
                <q-header>
                    <q-toolbar>
                        <q-toolbar-title>{{ $gettext('REPRESENTATIVE_DOCUMENT') }}</q-toolbar-title>
                        <q-btn flat @click="closeModal">
                            <q-icon name="close" />
                        </q-btn>
                    </q-toolbar>
                </q-header>
                <q-page-container>
                    <q-page padding>
                        <div v-if="extension === extensions.pdf">
                            <pdf
                                v-for="page in numPages"
                                ref="pdfViewer"
                                :key="page"
                                :page="page"
                                :src="source"
                                :v-if="source"
                                class="full-height full-width"
                                @num-pages="pageCount = $event"
                                @page-loaded="currentPage = $event"
                            />
                        </div>
                        <img v-else-if="extension === extensions.jpg || extension === extensions.png" :src="source">
                    </q-page>
                </q-page-container>
            </q-layout>
        </q-dialog>
</template>

<script>
import { Component, Vue } from 'vue-property-decorator'
import { repository } from 'jtech'
import pdf from 'vue-pdf'

@Component({
  name: 'RepresentativeFileModal',
  components: {
    pdf
  },
  props: {
    buttonName: String,
    params: Object
  }
})
class RepresentativeFileModal {
    currentPage = 0
    extensions = { pdf: 'pdf', jpg: 'jpg', png: 'png' }
  pageCount = 0
  numPages = 0
  source = ''
  renderModal = false
  extension = ''

  mounted () {
    const nmIdentificacaoParserFile = 'CONSUMER_UNIT_FILE'
    if (this.buttonName === 'icDownload') {
      this.btDownload(this.params, nmIdentificacaoParserFile)
    } else if (this.buttonName === 'icDetalharArquivo') {
      this.showDocument(this.params, nmIdentificacaoParserFile)
    }
  }

  closeModal () {
    this.$emit('close-modal', {})
  }

  async btDownload (params, nmIdentificacaoParserFile) {
    const file = await repository.downloadFile(
      params.name,
      null,
      nmIdentificacaoParserFile
    )
    const link = document.createElement('a')
    link.download = params.name
    link.href = URL.createObjectURL(file)
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    this.closeModal()
  }

  async showDocument (params, nmIdentificacaoParserFile) {
    this.extension = params.fileExtension
    const file = await repository.downloadFile(
      params.name,
      null,
      nmIdentificacaoParserFile
    )
    const link = document.createElement('a')

    const src = URL.createObjectURL(file)
    if (this.extension === this.extensions.pdf) {
      this.source = pdf.createLoadingTask(src)
      if (this.source.promise.then) {
        this.source.promise.then(p => {
          this.numPages = p.numPages
        })
      } else {
        this.numPages = 1
      }
    } else {
      this.source = src
    }
    this.$refs.docModal.show()
  }
}

export default RepresentativeFileModal
</script>

<style>

</style>
